// export const TECHNICAL_KEYWORDS = [
//   "javascript", "react", "node", "python", "java", "sql", "api",
//   "backend", "frontend", "database", "cloud", "aws", "docker",
//   "kubernetes", "system design", "algorithms", "data structures"
// ];

export const TECHNICAL_KEYWORDS = [
  "javascript", "typescript", "python", "java", "c", "c++", "c#", "go",
  "react", "next", "angular", "vue", "html", "css", "tailwind", "bootstrap",
  "node", "express", "nestjs", "spring", "django", "flask", "fastapi",
  "sql", "mysql", "postgres", "mongodb", "redis", "database",
  "api", "rest", "graphql", "microservices", "system design",
  "cloud", "aws", "azure", "gcp", "docker", "kubernetes", "ci", "cd",
  "algorithms", "data structures", "oops", "operating system", "computer networks"
];

export const HR_KEYWORDS = [
  "communication", "culture", "leadership", "teamwork",
  "conflict", "behavioral", "soft skills", "ethics",
  "motivation", "adaptability", "time management",
  "work ethic", "problem solving", "decision making",
  "responsibility", "attitude", "learning mindset",
  "strengths", "weaknesses", "career goals"
];

// export const HR_KEYWORDS = [
//   "communication", "culture", "leadership", "teamwork",
//   "conflict", "behavioral", "soft skills", "ethics",
//   "motivation", "adaptability", "time management"
// ];

export const HR_ROLE_KEYWORDS = [
  "hr", "human", "human resource", "human resources",
  "hr manager", "hr executive", "hr generalist",
  "recruiter", "recruitment", "talent acquisition",
  "people operations", "people ops", "people manager",
  "manager", "operations", "operations manager",
  "admin", "administrator", "office management"
];

export const TECH_ROLE_KEYWORDS = [
  "developer", "engineer", "programmer", "software",
  "frontend", "backend", "full stack", "fullstack",
  "data analyst", "data scientist", "business analyst",
  "qa", "tester", "automation tester", "devops",
  "mobile developer", "android", "ios",
  "machine learning", "ai engineer"
];